import { styled } from '@linaria/react';
import { Ref } from 'react';

import { uiToken } from '~/shared/constants/uiToken.ts';

import { StyledBasicInput } from './components/BasicInput/BasicInput.ui.ts';

const defaultBoxShadow = `0px 0px 0px 5px ${uiToken.color.shadow.default} inset`;
const errorBoxShadow = `0px 0px 0px 5px ${uiToken.color.shadow.error} inset`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StyledLabel = styled.label`
  font-size: 11px;
  font-weight: 400;
  color: ${uiToken.color.text.secondary};
  margin-bottom: 8px;
  margin-left: 16px;
  line-height: 1.2;

  animation: fadeIn 0.2s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const StyledInput = styled(StyledBasicInput)<{
  isInvalid?: boolean;
  ref?: Ref<HTMLInputElement>;
}>`
  padding: 12px;
  border-radius: 12px;
  border: 0.5px solid transparent;
  box-shadow: ${(props) => (props.isInvalid ? errorBoxShadow : 'none')};
  transition:
    box-shadow 0.2s ease-in-out,
    border-color 0.2s ease-in-out;

  @media (hover: none) {
    box-shadow: ${(props) => (props.isInvalid ? errorBoxShadow : 'none')};
  }

  &:hover {
    border-color: ${(props) =>
      props.isInvalid
        ? uiToken.color.system.error
        : uiToken.color.border.hover};
    box-shadow: ${(props) =>
      props.isInvalid ? errorBoxShadow : defaultBoxShadow};
  }

  &:disabled {
    background-color: transparent;
    box-shadow: none;
    border-color: transparent;
  }

  &:focus,
  &:focus:hover {
    box-shadow: ${(props) =>
      props.isInvalid ? errorBoxShadow : defaultBoxShadow};
  }

  &::placeholder {
    color: ${(props) =>
      props.isInvalid
        ? `var(${uiToken.color.system.error})`
        : `var(${uiToken.color.text.secondary})`};
  }

  &:focus::placeholder {
    color: ${(props) =>
      props.isInvalid
        ? `var(${uiToken.color.system.error})`
        : `var(${uiToken.color.text.disabled})`};
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }
`;
